import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-risk-clinical-operations-dashboard-coding-accuracy-view-details",
  templateUrl: "./risk-clinical-operations-dashboard-coding-accuracy-view-details.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskClinicalOperationsDashboardCodingAccuracyViewDetailsComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_CODING_ACCURACY_VIEW_DETAILS;
  hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID, HideFilters.PROJECT_NAME];
}
